export default {
    // 列表
    hardWareStoreShow: "/settings/materialVendor/show",
    // 新增
    hardWareStoreAdd: "/settings/materialVendor/addMaterialVendor",
    // 修改
    hardWareStoreEdit: "/settings/materialVendor/updateMaterialVendor",
    // 删除
    hardWareStoreDelete: "/settings/materialVendor/deleteByIds",
};
